import PropTypes from 'prop-types';

import { RESOURCE_TYPES } from '../../../constants';

/**
 * Configuration settings for the resource types to use in Content Builder.
 */
const config = PropTypes.shape({

	[RESOURCE_TYPES.MIRO]: PropTypes.bool,

	[RESOURCE_TYPES.SLIDE]: PropTypes.bool,

	[RESOURCE_TYPES.IMAGE]: PropTypes.bool,

	[RESOURCE_TYPES.VIDEO]: PropTypes.bool,

	[RESOURCE_TYPES.EMBED]: PropTypes.bool,

	[RESOURCE_TYPES.FORM]: PropTypes.bool,

	[RESOURCE_TYPES.POLL]: PropTypes.bool,

	[RESOURCE_TYPES.QUIZ]: PropTypes.bool,

});

export default {
	config,
};
